/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getSentMessages(campaignId, params) {
    return axios.get(`${this.url}/${campaignId}/sent_messages`, { params });
  }
}

export default new CampaignsAPI();
